import { render, staticRenderFns } from "./UpcomingDueMilestoneWidget.vue?vue&type=template&id=df9b94e0&"
import script from "./UpcomingDueMilestoneWidget.vue?vue&type=script&lang=js&"
export * from "./UpcomingDueMilestoneWidget.vue?vue&type=script&lang=js&"
import style0 from "./UpcomingDueMilestoneWidget.vue?vue&type=style&index=0&id=df9b94e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports